/* import __COLOCATED_TEMPLATE__ from './add-card-flow.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SiteBillingPaymentModalCheckoutFlowsAddCardFlow extends Component {
  @service billingModals;
  @service currentPractice;
  @service stripePaymentElementService;
  @service stripePaymentModeElementService;

  get isPaymentSubmitDisabled() {
    return (
      !this.stripePaymentElementService.isLoaded ||
      this.billingModals.isPersisting ||
      this.billingModals.isPaymentInvalid
    );
  }

  @action
  exitAddingCard() {
    this.stripePaymentModeElementService.update({ paymentMethodTypes: ['card', 'link'] });
    this.billingModals.setDefaultCard();
  }
}
